module.exports = __webpack_public_path__ + "img/factory-accident.66fdcd44.png";